import LOCAL_STORAGE_KEYS from "constants/STORAGE_KEYS";
import { FetchError, FetchSuccess, fetchBase } from "./managers";

export const getSignUpFields = async (eventCode) => {
  try {
    const res = await fetchBase(
      `user-dashboard/signup-form/${eventCode}`,
      null,
      {
        decrypt: true,
      },
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const submitSignup = async (payload) => {
  try {
    const res = await fetchBase(
      `user-dashboard/signup`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
      {
        decrypt: true,
        encrypt: true,
      },
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const sendSms = async (payload) => {
  try {
    const res = await fetchBase(
      `user-dashboard/send-verification-sms`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
      {
        decrypt: true,
        encrypt: true,
      },
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const sendVerifyCode = async (payload) => {
  try {
    const res = await fetchBase(
      `user-dashboard/verify-code`,
      {
        method: "POST",
        body: JSON.stringify(payload),
      },
      {
        decrypt: true,
        encrypt: true,
      },
    );
    return new FetchSuccess(res, {
      message: "Code had been verified successfully",
    });
  } catch (res) {
    throw new FetchError(res);
  }
};

export const getVisitorDetails = async () => {
  const eventCode = localStorage.getItem(LOCAL_STORAGE_KEYS.eventCode);
  try {
    const res = await fetchBase(
      `user-dashboard/register-user-data?event_token=${eventCode}`,
      null,
      {
        decrypt: true,
        encrypt: true,
        slugTarget: "url",
      },
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};

export const updateVisitorDetails = async (payload) => {
  const eventCode = localStorage.getItem(LOCAL_STORAGE_KEYS.eventCode);

  try {
    const res = await fetchBase(
      `user-dashboard/update-register-user?event_token=${eventCode}`,
      {
        method: "PATCH",
        body: JSON.stringify(payload),
      },
      {
        decrypt: true,
        encrypt: true,
        slugTarget: "url",
      },
    );
    return new FetchSuccess(res);
  } catch (res) {
    throw new FetchError(res);
  }
};
